import React, { useState, useEffect } from "react";
import axios from "axios";
import api from "../../../api/api";
import { useForm } from "react-hook-form";
import { createUserData } from "../../../features/userBlock/userBlockSlice";
import { useDispatch, useSelector } from "react-redux";
import { updatePermission } from "../../../features/permissions/permissionServices";
import AdminSearchCustomer from "../../servicesForms/common/AdminSearchCustomer";
import { toast } from "react-toastify";
import StaffDocumentView from "./StaffDocumentView";
const PermModelName = (item) => {
  return (
    <div className="flex items-center gap-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width="1em"
        height="1em"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={2}
          d="M20 12H4"
        />
      </svg>
      <svg
        id=""
        className="h-6 w-6 text-[#F8D775]"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width="1em"
        height="1em"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12c0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z"
        />
      </svg>
      {/* <p className="text-red-500">Task Assigned Details</p> */}
      {/* {
                          (index-1) >=0 ? 
                          (item.model === perm[index-1].model ? '' : 
                          <p>{item.model}</p> )
                          :<p className="text-red-500">{item.model}</p>
                        } */}
      .<p className="text-red-500">{item.model}</p>
    </div>
  );
};

const CreateStaff = () => {
  const [groups, setGroups] = useState([]);
  const [filter, setFilter] = useState("");
  const [perm, setPerm] = useState([]);
  const dispatch = useDispatch();
  const [role, setRole] = useState([]);
  const { register, handleSubmit, unregister } = useForm();
  const { register: register1, handleSubmit: handleSubmit1 } = useForm();

  const [userId, setUserId] = useState(null);
  const [change, setChange] = useState(false);
  const [documentItem,SetDocumentItem] = useState([])

  const [assignGroup, setAssignGroup] = useState([])


  const user = useSelector((state) => state.userBlock);

  const [staffDocs, setStaffDocs] = useState([])

  // useEffect(() => {
  //   console.log(role);
  // }, [role]);



  useEffect(() => {
    api.get("/downloads/staff-documents/")
      .then(response => {
        //  console.log('response.data',response.data)
        setStaffDocs(response.data)
      }).catch(error => {
        toast.error("Something went wrong")
      })
  }, [!change])



  const handleSub = async (data) => {
    data.user_type = "ST";
    // dispatchEvent(create)

    // console.log(data);
    // console.log("image", data.image[0]);

    const formData = new FormData();
    formData.append("first_name", data.first_name);
    formData.append("address", data.address);
    formData.append("father_name", data.father_name);
    formData.append("job_join_date", data.job_join_date);
    formData.append("phone", data.phone);
    formData.append("position", data.position);
    formData.append("password", data.password);

    formData.append("email", data.email);
    formData.append("image", data.image[0]);
    formData.append("messenger", data.messenger);
    formData.append("viber", data.viber);
    formData.append("whatsapp", data.whatsapp);
    formData.append("user_type", data.user_type);
    dispatch(createUserData(formData));
  };

  const handleUser = async (e) => {
    e.preventDefault();
    let user_id = user.users?.id;

    if (user_id === undefined || user === null) {
      alert("User id is not given");
      return "";
    }

    // if (role.length <= 0) {
    //   alert("Permission is not selected");
    // }

    if (assignGroup.length <= 0) {
      alert("Group is not selected")
    }

    console.log(assignGroup)

    const perm_data = { user: user_id, groups: assignGroup };

    api.put('users/groups/', perm_data)
      .then(response => {
        toast.success("Group Assign Properly")
      }).catch(error => {
        toast.error("Failed to assign Permission")
      })


    // dispatch(updatePermission(perm_data));
  };

  const handleStaffDocs = async (data) => {


    const formData = new FormData()
    formData.append("title", data.title)
    formData.append("staff", userId)
    formData.append("file", data.image[0])

    api.post('downloads/staff-documents/', formData)
      .then(response => {
        setChange(!change)
        toast.success("Staff documents uploaded")
      }).catch(error => {
        // console.log(error)
      })

  }

  useEffect(() => {
    api
      .get("users/groups/")
      .then((response) => {
        setGroups(response.data);
        // console.log(response.data[0].name)
        setFilter(response.data[0].name);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (filter !== "") {
      api
        .get(`users/groups/?name=${filter}`)
        .then((response) => {
          setPerm(response.data[0].permissions);
          // console.log(response.data[0].permissions);
          //  setPerm(response.data)
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [filter]);

  const handleChange = (id) => {
    if (role.includes(id)) {
      let newArr = [...role];
      newArr.pop(id);
      setRole(newArr);
      return;
    }

    setRole((prev) => [...prev, id]);
  };

  const handleStaffDelete = (id) => {
    api.delete(`/downloads/staff-documents/${id}/`)
      .then(response => {
        toast.success("Deleted successfully")
        setChange(!change)
      }).catch(error => {
        toast.error("unable to delete")
      })
  }


  const handleGroup = (item) => {
    setFilter(item.name)
    setAssignGroup([item.id])
  }


  return (
    <div className="px-3 md:px-10">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Staff Account
      </h1>

      <form onSubmit={handleSubmit(handleSub)}>
        <div className="">
          <img
            src="../../images/title-border.png"
            alt=""
            className="mx-auto mt-4"
          />
        </div>
        {/*  create staff */}
        <div className="">
          <div className="relative">
            <div className="w-ful grid grid-cols-1 text-lg sm:text-sm md:grid-cols-3 md:text-lg">
              <div className="text-primary-red border-primary-blue flex w-full items-center gap-3 border-x-2 border-t-2 p-2 font-medium md:border-l-2 md:border-r-0">
                <p className="flex-shrink-0">Staff Name :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Staff Name"
                  {...register("f_name", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-0 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Address</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Address"
                  {...register("address", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-2 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Job Join Date:</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="date"
                  {...register("job_join_date", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-0 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Father Name:</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Father Name"
                  {...register("father_name", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 p-2 font-medium md:border-l-2 md:border-r-0">
                <p className="flex-shrink-0">Post :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Post"
                  id=""
                  {...register("position", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-2 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Contact No :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="phone number"
                  {...register("phone", { required: false })}
                  id=""
                />
              </div>
            </div>
            <div className="text-primary-red border-primary-blue flex w-full items-center border-b-2 border-r-2 border-t-2 border-l-2 p-2 font-medium">
              <p className="flex-shrink-0">Staff Photo :</p>
              <input
                type="file"
                // name=""
                className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:border-0 file:rounded-lg file:text-white"
                id=""
                {...register("image", { required: false })}
              />
            </div>
          </div>
          {/* btns */}
          {/* <div className="flex justify-end">
          <a
            href=""
            className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
          >
            Save
          </a>
        </div> */}
        </div>
        {/* staff socila media */}
        <div className="">
          <h1 className="text-primary-red text-center font-bold underline">
            Social Media Link
          </h1>
          <div className="relative mt-3">
            <div className="w-ful grid grid-cols-1 text-lg sm:text-sm md:grid-cols-3 md:text-lg xl:grid-cols-4">
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 p-2 font-medium md:border-y-2 md:border-l-2">
                <p className="flex-shrink-0">Email :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Email"
                  {...register("email", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-y-2 p-2 font-medium md:border-l-0">
                <p className="flex-shrink-0">Messenger :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Facebook"
                  {...register("messenger", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-b-2 p-2 font-medium md:border-y-2 md:border-l-0 md:border-r-2">
                <p className="flex-shrink-0">Viber :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Viber"
                  {...register("viber", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-b-2 p-2 font-medium md:border-y-2 md:border-l-0 md:border-r-2">
                <p className="flex-shrink-0">Whatsapp :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Whatsapp"
                  {...register("whatsapp", { required: false })}
                />
              </div>
            </div>
          </div>
          {/* btns */}
          {/* <div className="flex justify-end">
          <a
            href=""
            className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
          >
            Save
          </a>
        </div> */}
        </div>
        {/* username and pass */}
        <div className="">
          <h1 className="text-primary-red text-center font-bold underline">
            Create Username and Password
          </h1>
          <div className="relative mt-3">
            <div className="w-ful grid grid-cols-1 text-lg sm:text-sm md:grid-cols-2 md:text-lg">
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 p-2 font-medium md:border-y-2 md:border-l-2">
                <p className="flex-shrink-0">Username :</p>
                <input
                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Username"
                  {...register("username", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-y-2 p-2 font-medium md:border-l-0">
                <p className="flex-shrink-0">Password :</p>
                <input
                  type="password"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Password"
                  {...register("password", { required: false })}
                />
              </div>
            </div>
          </div>
          {/* btns */}
          <div className="flex justify-end">
            {/* <a
            href=""
            className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
          >
            Save
          </a> */}
            <button type="submit" className="bg-primary-blue text-white hover:bg-primary-red rounded-xl my-3 px-3 text-lg">Submit</button>
          </div>
        </div>
      </form>

      {/* select depart and role */}
      <div className="">
        <p className="text-primary-red text-center font-bold underline">
          Select Depart and Role
        </p>
        <div className="mt-3 grid w-full grid-cols-1 flex-wrap overflow-x-auto my-3 sm:grid-cols-3 lg:grid-cols-5 xl:!grid-cols-8">
          <div className="text-primary-red border-primary-blue flex h-full items-center border-2 p-2 font-bold">
            Depart
          </div>

          {groups.map((item, i) => {
            return (
              <div className="bg-primary-red text-white" key={i}>
                <div className="border-primary-blue flex h-full flex-col items-center gap-2 border-2 p-2">
                  <label htmlFor="">{item.name}</label>
                  <input
                    type="radio"
                    name="role"
                    className="h-6 w-6"
                    id=""
                    // onChange={() => setFilter(item.name)}
                    onChange={() => handleGroup(item)}
                  />
                </div>
              </div>
            );
          })}

        </div>
      </div>

      <form onSubmit={handleUser}>
        {/* select individual role */}
        <section className="flex w-full ">
          <div className="  w-full  border-2 border-cyan-600 text-sm font-semibold text-red-600">
            <div className="grid grid-cols-12 items-center justify-center">
              <div className="col-span-1 flex-shrink-0 text-center">S.N.</div>
              <div className="col-span-11 border-l-2 border-cyan-600 text-center">
                1
              </div>
            </div>
            <div className="grid grid-cols-12 items-center justify-center border-t-2 border-cyan-600">
              <div className="col-span-1 px-1 text-center">Depart</div>
              <div className="col-span-11 flex flex-col items-center justify-center gap-1 border-l-2 border-cyan-600 bg-red-600 py-1 text-white">
                <h1>{filter}</h1>
                <div className="form-check">
                  <input
                    className="form-check-input float-left my-1 h-4 w-4 cursor-pointer appearance-none rounded-full border border-blue-900 bg-yellow-300 bg-contain bg-center bg-no-repeat align-top transition duration-200 checked:border-blue-600 checked:bg-blue-600 focus:outline-none"
                    type="checkbox"
                    defaultValue=""
                    defaultChecked=""
                    id="flexCheckDefault3"
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 border-t-2 border-cyan-600">
              <div className="col-span-1 flex items-center justify-center">
                Role
              </div>
              <div className="col-span-11 border-l-2 border-cyan-600">
                <div className="grid w-full grid-cols-1 text-base font-semibold capitalize text-cyan-600 md:grid-cols-2 md:py-0">
                  <div className="items-center px-2 md:py-1">

                    {perm.map((item, index) => {
                      return (
                        <div key={index}>
                          {index - 1 >= 0
                            ? item.model === perm[index - 1].model
                              ? ""
                              : PermModelName(item)
                            : PermModelName(item)}


                          <div className="flex items-center px-7">
                            <svg
                              className="h-5 w-5"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 24 24"
                            >
                              <g
                                fill="#fff"
                                stroke="#EE1D23"
                                strokeLinejoin="round"
                                strokeWidth={2}
                              >
                                <path
                                  strokeLinecap="round"
                                  d="M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2Zm5 9h6m-6 4h3"
                                />
                                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                              </g>
                            </svg>
                            <div className="flex items-center gap-1">
                              <h1>{item.name}</h1>
                              <div className="form-check">
                                {/* <input
                                  className="form-check-input float-left my-1 h-4 w-4 cursor-pointer appearance-none rounded-full border border-blue-900 bg-yellow-300 bg-contain bg-center bg-no-repeat align-top transition duration-200 checked:border-blue-600 checked:bg-blue-600 focus:outline-none"
                                  type="checkbox"
                                  defaultValue=""
                                  onChange={() => {
                                    handleChange(item.id);
                                  }}
                                  id="flexCheckDefault3"
                                /> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <button type="submit" className="float-right bg-primary-blue text-white hover:bg-primary-red rounded-xl my-3 px-3 text-lg">Submit</button>
      </form>

      {/* staff all document list */}
      <div className="w-full ">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <p className="text-primary-red font-bold underline">
                  Staff All Documnet List
                </p>
                {/* search */}
                <form className="mt-5 flex items-center gap-5 justify-around"
                  onSubmit={handleSubmit1(handleStaffDocs)}
                >
                  <input
                    type="file"
                    {...register1("image", { required: true })}
                    className="text-primary-blue file:border-0 file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
                  />

                  <input type="text"
                    placeholder="Documents Name"
                    className="border-primary-blue rounded-md text-primary-blue border outline-none px-2 py-2"
                    {...register1("title", { required: true })}
                  />

                  {/* <input
                    placeholder="Search by Document"
                    type="search"
                    className="my-3 rounded-lg border border-black p-3"
                  /> */}
                  <AdminSearchCustomer setUserId={setUserId} user_type="ST" />

                  <button type="submit"
                    className="bg-primary-blue  inline-flex gap-2 rounded-md px-4 py-2 font-bold text-white"
                  >
                    Submit
                  </button>
                </form>
                <table className="border-primary-blue min-w-full border text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr className="">
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Document Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        File type
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {
                      staffDocs.map((docs, i) => {
                        console.log("docs",docs)
                        return (
                          <tr className="border-primary-blue border-2 bg-white" key={i}>
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              {i + 1}
                            </td>
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              {docs.title}
                            </td>
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              {docs.file_type}
                            </td>
                            <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                              {/* <a
                              href=""
                              className="bg-primary-green rounded-full p-1 px-2 text-white"
                            >
                              View
                            </a> */}
                        
                          
                              <button
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModalEdit"
                                onClick={()=>SetDocumentItem(docs)}
                                className="bg-primary-red rounded-full p-1 mr-3 px-2 text-white"
                              >
                                View
                              </button>
                              <StaffDocumentView documentItem={documentItem}/>
                              {/* <StaffDocumentView/> */}
                              {/* <a
                              href=""
                              className="bg-primary-red rounded-full p-1 px-2 text-white"
                            > */}
                              <button
                                className="bg-primary-red rounded-full p-1 px-2 hover:bg-primary-blue text-white"
                                onClick={() => handleStaffDelete(docs.id)}>

                                Delete
                              </button>
                              {/* </a> */}
                            </td>
                          </tr>
                        )
                      })
                    }

                  </tbody>
                </table>
                <div className="mt-5 flex items-center justify-end gap-10">
                  <div className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                    <a href="">Save</a>
                  </div>
                  <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                    <a href="">Submit</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateStaff;
